<template>
    <div>
        <el-row class="warp">
            <el-col :span="24" class="warp-main" element-loading-text="拼命加载中">

                <el-button type="primary" @click="entity={provincenames:[]};dialogFormVisible=true">新增</el-button>

                <el-table :data="areaList" style="width: 100%">
                    <el-table-column label="序号" type="index" width="80"></el-table-column>
                    <el-table-column label="地区" prop="areaname" width="120"></el-table-column>

                    <el-table-column label="操作" width="250">
                        <template slot-scope="scope">
                            <el-button size="mini" @click="findById(scope.row.id);dialogFormVisible = true">编辑
                            </el-button>
                            <el-button size="mini" type="danger" @click="handleDelete(scope.row.id)">删除</el-button>
                        </template>
                    </el-table-column>

                </el-table>

                <el-dialog title="地区编辑" :visible.sync="dialogFormVisible">
                    <el-form label-width="80px">
                        <el-form-item label="地区">
                            <el-input v-model="entity.areaname" aria-placeholder="地区"></el-input>
                        </el-form-item>

                        <el-form-item label="省">
                            <template>
                                <el-select v-model="entity.provincenames" multiple placeholder="请选择">
                                    <el-option
                                            v-for="item in options"
                                            :key="item.value"
                                            :label="item.label"
                                            :value="item.label">
                                    </el-option>
                                </el-select>
                            </template>
                        </el-form-item>

                    </el-form>

                    <div slot="footer" class="dialog-footer">
                        <el-button @click="dialogFormVisible=false">取消</el-button>
                        <el-button @click="save">提交</el-button>
                    </div>
                </el-dialog>

            </el-col>
        </el-row>
    </div>
</template>
<script>

import areaApi from "../../../api/area/index";
import {provinceAndCityData} from 'element-china-area-data';

export default {
    data() {
        return {
            options: provinceAndCityData,
            dialogFormVisible: false,
            entity: {},
            areaList: []
        }
    }
    ,
    created() {
        this.findAll()
    }
    ,
    methods: {
        findAll() {
            areaApi.findAll().then(response => {
                this.areaList = response.data
            })
        }
        ,
        findById(id) {
            areaApi.findById(id).then(response => {
                this.entity = response.data
                if (response.data.provincenames == null) {
                    this.entity.provincenames = [];
                }
            })
        }
        ,
        handleDelete(id) {
            this.$confirm('此操作将永久删除该地区下所有省份信息, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                areaApi.handleDelete(id).then(response => {
                    this.$message({
                        type: response.code == 0 ? 'success' : 'error',
                        message: '删除成功!'
                    });
                    this.findAll()
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });
        }
        ,
        save() {
            if (this.entity.id == null) {
                areaApi.add(this.entity).then(response => {
                    this.$message({
                        message: response.message,
                        type: response.code == 0 ? 'success' : 'error'
                    })
                    this.dialogFormVisible = false
                    this.findAll()
                })
            } else {
                areaApi.update(this.entity).then(response => {
                    this.$message({
                        message: response.message,
                        type: response.code == 0 ? 'success' : 'error'
                    })
                    this.dialogFormVisible = false
                    this.findAll()
                })
            }
        }
        ,
    },


}
;
</script>
<style scoped></style>
